export const $address = Symbol('address');
export const $token = Symbol('token');
export const $tokens = Symbol('tokens');
